/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Link } from '@bingads-webui-campaign-react/router';
import { Divider, SummaryBar } from '@bingads-webui-campaign/reports-v4-summary-bar';
import IWindow from '@bingads-webui-clientcenter/window-interface';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { FontIcon, IconButton, Stack, TooltipHost } from '@fluentui/react';
import { blackColorClassName, boldClassName, stackItemCenterStyle } from '../../style';
import { Trivia } from './trivia';

export function ReportsV4SummaryBar(props) {
  const {
    onSchedulerSaveClick,
    schedulerOptions,
    reportName,
    typeOfReport,
    timeTravelOptions,
    forceRefreshData,
    shouldHideThisFunctionality,
  } = props;

  const i18n = useContext(I18nContext);
  const refreshText = i18n.getString(_TL_('Refresh'));

  return (
    <SummaryBar>
      <Divider />
      <BreadcrumbContainer reportName={reportName} />
      <Divider />
      {!shouldHideThisFunctionality &&
        <Trivia
          onSchedulerSaveClick={onSchedulerSaveClick}
          schedulerOptions={schedulerOptions}
          typeOfReport={typeOfReport}
        />}
      <Divider />
      {!shouldHideThisFunctionality &&
        <TimeTravelButtonGroups
          isRedoEnabled={timeTravelOptions.isRedoEnabled}
          onRedoClick={timeTravelOptions.onRedoClick}
          isUndoEnabled={timeTravelOptions.isUndoEnabled}
          onUndoClick={timeTravelOptions.onUndoClick}
          isResetEnabled={timeTravelOptions.isResetEnabled}
          onResetClick={timeTravelOptions.onResetClick}
        />}
      <Divider />
      <IconButton id="refresh-button" iconProps={{ iconName: 'Refresh' }} title={refreshText} aria-label={refreshText} disabled={false} onClick={forceRefreshData} />
    </SummaryBar>
  );
}

export function ReportsV4SummaryBarWithOnlyName(props) {
  const {
    reportName,
  } = props;
  return (
    <SummaryBar>
      <Divider />
      <BreadcrumbContainer reportName={reportName} />
    </SummaryBar>
  );
}

const myReportsPageHref = '/campaign/vnext/reports-v4/my-reports/customized';
const defaultReportsPageHref = '/campaign/vnext/reports-v4/default-reports';

const homePageHref = '/campaign/vnext/reporting/home';
const templatePageHref = '/campaign/vnext/reporting/templates';

export function BreadcrumbContainer(props) {
  const { reportName } = props;
  const [, reportAction] = IWindow.location.pathname.match(/\/(edit|create)/);
  const i18n = useContext(I18nContext);
  const permissions = useContext(PermissionsContext);
  const isNewLandingPage = permissions.dynamic.CustomReports;

  let parentLevel;
  let parentHref;
  switch (reportAction) {
    case 'edit':
      parentLevel = isNewLandingPage ? i18n.getString(_TL_('Home')) : i18n.getString('My reports');
      parentHref = isNewLandingPage ? homePageHref : `${myReportsPageHref}`;
      break;
    case 'create':
      parentLevel = isNewLandingPage ? i18n.getString(_TL_('Templates')) : i18n.getString('Default reports');
      parentHref = isNewLandingPage ? templatePageHref : `${defaultReportsPageHref}`;
      break;
    default:
      throw new Error();
  }

  const itemsWithHeading = [
    { text: parentLevel, key: 'level-1', href: parentHref },
    { text: reportName || 'loading...', key: 'level-2', isCurrentItem: true },
  ];

  return (
    <Stack
      className="breadcrumb-navigation"
      horizontal
      tokens={{ childrenGap: 4, padding: 8 }}
    >
      <Stack.Item styles={stackItemCenterStyle}>
        <Link className={blackColorClassName} to={{ pathname: itemsWithHeading[0].href, search: window.location.search }}>
          <span>
            {itemsWithHeading[0].text}
          </span>
        </Link>
      </Stack.Item>
      <Stack.Item styles={stackItemCenterStyle}>
        <FontIcon aria-label="ChevronRight" iconName="ChevronRight" />
      </Stack.Item>
      <Stack.Item styles={stackItemCenterStyle}>
        <span className={boldClassName} title={itemsWithHeading[1].text}>
          {itemsWithHeading[1].text}
        </span>
      </Stack.Item>
    </Stack>
  );
}


function TimeTravelButtonGroups(props) {
  const {
    className,
    isRedoEnabled, isUndoEnabled,
    onRedoClick, onUndoClick,
    isResetEnabled,
    onResetClick,
  } = props;
  const i18n = useContext(I18nContext);

  const undoText = i18n.getString(_TL_('Undo'));
  const redoText = i18n.getString(_TL_('Redo'));
  const resetText = i18n.getString(_TL_('Reset'));

  const calloutProps = { gapSpace: 0 };
  const hostStyles = { root: { display: 'inline-block' } };

  return (
    <Stack className={className} horizontal tokens={{ childrenGap: 8, padding: 8 }}>
      <Stack.Item styles={stackItemCenterStyle}>
        <TooltipHost
          content={undoText}
          id="UndoToolTip"
          calloutProps={calloutProps}
          styles={hostStyles}
        >
          <IconButton id="undo-button" iconProps={{ iconName: 'Undo' }} title={undoText} aria-label={undoText} disabled={!isUndoEnabled} onClick={onUndoClick} />
        </TooltipHost>
      </Stack.Item>
      <Stack.Item styles={stackItemCenterStyle}>
        <TooltipHost
          content={redoText}
          id="RedoToolTip"
          calloutProps={calloutProps}
          styles={hostStyles}
        >
          <IconButton id="redo-button" iconProps={{ iconName: 'Redo' }} title={redoText} aria-label={redoText} disabled={!isRedoEnabled} onClick={onRedoClick} />
        </TooltipHost>
      </Stack.Item>
      <Stack.Item styles={stackItemCenterStyle}>
        <TooltipHost
          content={resetText}
          id="ResetToolTip"
          calloutProps={calloutProps}
          styles={hostStyles}
        >
          <IconButton id="reset-button" iconProps={{ iconName: 'RevToggleKey' }} title={resetText} aria-label={resetText} disabled={!isResetEnabled} onClick={onResetClick} />
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
}
